import {ready} from '@/shared'

ready(function () {
  var lazyLoadInstance = new LazyLoad({ // eslint-disable-line
    elements_selector: '.lazy-picture',
    callback_error: function (image) {
      var imageParent = image.parentNode
      var imageSrc = image.getAttribute('src')
      var id = image.getAttribute('id')

      image.parentNode.innerHTML = ''

      var fallbackImage = document.createElement('img')
      fallbackImage.src = imageSrc // eslint-disable-line
      fallbackImage.setAttribute('data-src', imageSrc)
      fallbackImage.id = id
      fallbackImage.className = 'lazy-picture-fallback loaded'

      imageParent.appendChild(fallbackImage)
    }
  })
  if (lazyLoadInstance) {
    lazyLoadInstance.update(); // eslint-disable-line
  }
})



// WEBPACK FOOTER //
// ./src/image-lazy-loading.js